import cookies from 'js-cookie'
import { FreeTrial, FreeTrialService } from '@mc/api'

const noFreeTrial = {
  eligible: false,
  source: { name: 'no_free_trial' },
  advocate: {},
  partnership: undefined,
  isPartnershipTrial: false,
  isGuestPass: false,
  termsLink: '/',
  durationDays: undefined,
}

let freeTrial: FreeTrial | typeof noFreeTrial | undefined

export const getFreeTrialPropertiesAsync = async (refresh = false) => {
  if (!!freeTrial && !refresh) {
    return freeTrial
  }

  const referralToken = cookies.get('referral_token')

  freeTrial = referralToken
    ? await FreeTrialService.getGuestPasses({ referralToken })
    : noFreeTrial

  return freeTrial
}
